export enum PersonType {
    RESTAURATEUR = 'restaurateur',
    NON_RESTAURATEUR = 'non_restaurateur',
    OTHER = 'other',
}
